module.exports = __webpack_public_path__ + "img/avatar1.56d628cf.png";